import {
    NEW_AUTHORIZATION_SET_TYPE,
    NEW_AUTHORIZATION_SET_SPONSOR,
    NEW_AUTHORIZATION_ERROR,
    NEW_AUTHORIZATION_SET_SPONSOR_FORM,
    SET_SPONSOR_SEARCH_METHOD,
    SET_INPUTS_SPONSOR_SEARCH_VALUES,
    AUTHORIZATIONS_ERROR,
    AUTHORIZATIONS_SUCCESS,
    AUTHORIZATONS_LOADING,
    BENEFICIARIES_SUCCESS,
    SET_BENEFICIARY_SELECTED,
    SET_BENEFICIARY_SELECTION,
    COMPLETE_TYPE_STEP,
    COMPLETE_SPONSOR_STEP,
    COMPLETE_METHOD_STEP,
    COMPLETE_BENEFICIARY_STEP,
    COMPLETE_BENEFICIARY_SEARCH,
    SET_BENEFICIARY,
    FIND_BENEFIRIARY_ERROR,
    SET_AUTHORIZATION_FORM_VALUES,
    SET_BIOMETRIC_VERIFICATION_RESULT,
    SET_LOADING_VERIFICATION,
    SET_CREATE_CLAIM_ERROR,
    SET_LOADING_CREATE_CLAIM,
    SET_NAVBAR_TYPE,
    CLEAR_NEW_AUTHORIZATION,
    SET_CREATE_CLAIM_RESULT,
    AUTHORIZATION_DETAIL_SUCCESS,
    AUTHORIZATION_DETAIL_HEADER,
    CLEAR_AUTHORIZATION_DETAIL,
    DIALOG_AUTHORIZATION_FILES_ATTACH,
    AUTHORIZATION_DETAIL_FILE,
    AUTHORIZATION_CREATION_BACK_STEP,
    AUTHORIZATION_CREATION_NEXT_STEP,
    SET_PRESCRIPTION,
    CLEAR_AUTHORIZATION_REQUEST_VALUES,
    PRESCRIPTION_CREATED,
    CLEAR_PRESCRIPTION,
    SET_SPONSOR_PRODUCTS,
    SET_SPONSOR_PRODUCT_DETAIL,
    DISPENSING_LOADING,
    DISPENSING_ERROR,
    SET_DISPENSING_COSHARINGS,
    DISPENSATION_CREATION_LOADING,
    SET_COMPLETED_DISPENSATION,
    CLEAR_DISPENSATION,
    SET_SPONSORS,
    SET_PROVIDER_PRODUCT_TYPES,
    SET_BIOMETRIC_VERIFICATION_REQUIRED,
    RESET_BIOMETRIC_VALIDATION,
    SET_SPONSOR_DOCUMENT_POLICY,
    SET_PROVIDER_INFORMATION,
    SET_BIOMETRIC_VERIFICATION_METHOD,
    SET_SPONSOR_ENABLE_UPDATE_DATA,
    SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS,
    SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR
  } from './types';

export default {

    [CLEAR_NEW_AUTHORIZATION]: (state) => {
        state.newAuthorization = {
            sponsors: [],
            type: {},
            error: {},
            sponsorForm: [],
            beneficiarySearch: {
              isAllowBeneficiaryDataUpdate: false,
              sponsorSlug: null,
              formSlug: null,
              inputs: []
            },
            steps: {
              type: false,
              sponsor: false,
              method: false,
              beneficiary: false,
              beneficiarySearchComplete: false
            },
            navBarType: '',
            actualStep: 1,
            providerProducts: [],
            providerProductTypes: [],
            biometricVerificationRequired: true,
            sponsorDocumentPolicy: []
        }
        state.beneficiaries = [],
        state.beneficiarySelected = {},
        state.authorizationFormValues = {
            beneficiaryFields: {},
            doctorFields: {},
            isVerified: null,
            requirements: undefined
        }
        state.filters= [],
        state.sponsorTransactionCoverageTypeRequirementsError
    },

    [CLEAR_AUTHORIZATION_REQUEST_VALUES]: (state) => {
        if(state.authorizationFormValues.doctorFields.treatments){
            state.authorizationFormValues.doctorFields.treatments = []
        }
        if(state.authorizationFormValues.doctorFields.products){
            state.authorizationFormValues.doctorFields.products = []
        }
    },

    [SET_NAVBAR_TYPE]: (state, payload) => {
        state.newAuthorization.navBarType = payload
    },

    [COMPLETE_BENEFICIARY_SEARCH]: (state, payload) => {
        state.newAuthorization.steps.beneficiarySearchComplete = payload
    },

    [COMPLETE_TYPE_STEP]: (state, payload) => {
        state.newAuthorization.steps.type = payload
    },

    [COMPLETE_SPONSOR_STEP]: (state, payload) => {
        state.newAuthorization.steps.sponsor = payload
    },

    [COMPLETE_METHOD_STEP]: (state, payload) => {
        state.newAuthorization.steps.method = payload
    },

    [COMPLETE_BENEFICIARY_STEP]: (state, payload) => {
        state.newAuthorization.steps.beneficiary = payload
    },

    [NEW_AUTHORIZATION_SET_TYPE]: (state, payload) => {
        state.newAuthorization.type = payload
    },

    [NEW_AUTHORIZATION_SET_SPONSOR]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.sponsorSlug = payload
    },

    [NEW_AUTHORIZATION_ERROR]: (state, payload) => {
        state.newAuthorization.error = payload
    },

    [NEW_AUTHORIZATION_SET_SPONSOR_FORM]: (state, payload) => {
        state.newAuthorization.sponsorForm = payload
    },

    [SET_SPONSOR_ENABLE_UPDATE_DATA]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.isAllowBeneficiaryDataUpdate = payload
    },

    [SET_SPONSOR_SEARCH_METHOD]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.formSlug = payload
    },

    [SET_INPUTS_SPONSOR_SEARCH_VALUES]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.inputs = payload
    },

    [BENEFICIARIES_SUCCESS]: (state, payload) => {
        state.beneficiaries = payload
    },

    [SET_BENEFICIARY_SELECTED]: (state, payload) => {
        state.beneficiarySelected = payload
    },

    [SET_BENEFICIARY_SELECTION]: (state, payload) => {
        state.isBeneficiarySelected= payload
    },

    [AUTHORIZATIONS_SUCCESS]: (state, payload) => {
        state.authorizations = payload.content
        state.links = payload.links
        state.page = payload.page
    },

    [AUTHORIZATIONS_ERROR]: (state, payload) => {
        state.errorAlert = payload
    },
    
    [AUTHORIZATONS_LOADING]: (state, payload) => {
        state.loadingAuthorizations = payload
    },

    [SET_BENEFICIARY]: (state, payload) => {
        state.beneficiary = payload
    },

    [FIND_BENEFIRIARY_ERROR]: (state, payload) => {
        state.beneficiaryError = payload
    },

    [SET_AUTHORIZATION_FORM_VALUES] (state, payload) {
        state.authorizationFormValues = payload
    },

    [SET_BIOMETRIC_VERIFICATION_RESULT](state, payload) {
        state.biometricVerificationResult = payload
        state.authorizationFormValues.isVerified = payload ? payload.verificationStatus === 'VERIFICATION_SUCCESS' : null
    },

    [SET_LOADING_VERIFICATION](state, isLoading) {
        state.loadingVerification = isLoading
    },

    [SET_CREATE_CLAIM_ERROR](state, errorObject) {
        state.createClaimError = errorObject
    },

    [SET_LOADING_CREATE_CLAIM](state, isLoading) {
        state.loadingCreateClaim = isLoading
    },

    [SET_CREATE_CLAIM_RESULT](state, payload) {
        state.authorizationResult = payload
    },

    [AUTHORIZATION_DETAIL_SUCCESS]: (state, payload) => {
        state.authorizationDetail.detail = payload
    },

    [AUTHORIZATION_DETAIL_HEADER]: (state, payload) => {
        state.authorizationDetail.header = payload
    },

    [CLEAR_AUTHORIZATION_DETAIL]:(state) => {
        state.authorizationDetail.header = {}
        state.authorizationDetail.detail = {}
        state.authorizationDetail.sponsorProduct = {}
        state.page = {}
    },

    [DIALOG_AUTHORIZATION_FILES_ATTACH]: (state, payload) => {
        state.dialogAuthorizationFilesAttach = payload
    },

    [AUTHORIZATION_DETAIL_FILE]: (state, payload) => {
        state.authorizationDetail.attachedFile = payload
    },

    [AUTHORIZATION_CREATION_BACK_STEP]: (state) => {
        if(state.newAuthorization.actualStep > 1){
            state.newAuthorization.actualStep--;
        }
    },

    [AUTHORIZATION_CREATION_NEXT_STEP]: (state) => {
        state.newAuthorization.actualStep++;
    },

    [PRESCRIPTION_CREATED]: (state, payload)=> {
        state.prescriptionCreated = payload
    },

    [SET_PRESCRIPTION]: (state, payload) => {
        state.prescription = payload
    },

    [CLEAR_PRESCRIPTION]: (state) => {
        state.prescription = {}
    },
    
    [SET_SPONSOR_PRODUCTS]: (state, payload) => {
        state.newAuthorization.providerProducts = payload
    },

    [SET_SPONSOR_PRODUCT_DETAIL]: (state, payload) => {
        state.authorizationDetail.sponsorProduct = payload
    },

    [DISPENSING_LOADING]: (state, payload) => {
        state.dispensation.loading.general = payload
    },

    [DISPENSING_ERROR]: (state, payload) => {
        state.dispensation.error = payload
    },

    [SET_DISPENSING_COSHARINGS]: (state, payload) => {
        state.dispensation.cosharings = payload
    },

    [DISPENSATION_CREATION_LOADING]: (state, payload) => {
        state.dispensation.loading.creation = payload
    },

    [SET_COMPLETED_DISPENSATION]: (state, payload) => {
        state.dispensation.dispensationResult = payload
    },

    [CLEAR_DISPENSATION]: (state) => {
        state.dispensation.cosharings = {}
    },

    [SET_SPONSORS]: (state, payload) => {
        state.newAuthorization.sponsors = payload.content
    },

    [SET_PROVIDER_PRODUCT_TYPES]: (state, payload) => {
        state.newAuthorization.providerProductTypes = payload
    },

    [SET_BIOMETRIC_VERIFICATION_REQUIRED]: (state, payload) => {
        state.newAuthorization.biometricVerificationRequired = payload
    },
        
    [RESET_BIOMETRIC_VALIDATION]: (state) => {
        state.authorizationFormValues.isVerified = null
    },

    [SET_SPONSOR_DOCUMENT_POLICY]: (state, payload) => {
        state.newAuthorization.sponsorDocumentPolicy = payload
    },

    [SET_PROVIDER_INFORMATION]: (state, payload) => {
        state.providerName = payload.name
        state.providerLegalName = payload.legalName
    },

    [SET_BIOMETRIC_VERIFICATION_METHOD]: (state, payload) => {
        state.biometricVerificationMethod = payload
    },

    [SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS]: (state, payload) => {
        state.authorizationFormValues.requirements = payload.transactionCoverageTypeRequirement
    },

    [SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR]: (state, payload) => {
        state.sponsorTransactionCoverageTypeRequirementsError = payload
    }
 
}
